import { AsmScopesViewId } from '../models/asm-scopes-view-id';
import { AsmScopesType } from '../models/asm-scopes-type';
import { SolType, SolViewId, TypeService, ViewService } from '@sol/components';

export function provideAsmScopesViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmScopesType.scopeModule);
  typeService.addType(AsmScopesType.subscopeName);
  viewService.addView(
    AsmScopesType.scopeModule,
    'read',
    AsmScopesViewId.scopeModule,
    () => import('../components/core/asm-scope-module/asm-scope-module.component').then(m => m.AsmScopeModuleComponent),
    true,
  );
  viewService.addView(
    SolType.string.array,
    'edit',
    AsmScopesViewId.subscopeSeedSelectEdit,
    () =>
      import('../components/view/asm-view-edit-subscope-seed-select/asm-view-edit-subscope-seed-select.component').then(
        m => m.AsmViewEditSubscopeSeedSelectComponent,
      ),
    false,
  );
  viewService.addView(
    AsmScopesType.subscopeName,
    'edit',
    AsmScopesViewId.subscopeNameEdit,
    () =>
      import('../components/view/asm-view-edit-subscope-name/asm-view-edit-subscope-name.component').then(
        m => m.AsmViewEditSubscopeNameComponent,
      ),
    true,
  );
  viewService.addView(
    AsmScopesType.subscopeName.array,
    'edit',
    AsmScopesViewId.subscopeNameEdit,
    () =>
      import('../components/view/asm-view-edit-subscope-name/asm-view-edit-subscope-name.component').then(
        m => m.AsmViewEditSubscopeNameComponent,
      ),
    true,
  );
  viewService.deriveView(SolType.string.array, 'read', AsmScopesType.subscopeName, SolViewId.textField, {
    isDefault: true,
    mapValue: (name: string) => [name],
  });
}
